export function PatternOverlay() {
  return (
    <div aria-hidden="true" className="absolute inset-0 opacity-[0.06]">
      <svg
        className="h-full w-full"
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="dots"
            x="0"
            y="0"
            width="32"
            height="32"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="1.5" cy="1.5" r="1.1" fill="rgba(255,255,255,0.14)" />
          </pattern>
          <linearGradient id="fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="rgba(255,255,255,0.55)" />
            <stop offset="0.35" stopColor="rgba(255,255,255,0.12)" />
            <stop offset="0.75" stopColor="rgba(255,255,255,0.04)" />
            <stop offset="1" stopColor="rgba(255,255,255,0)" />
          </linearGradient>
          <mask id="mask">
            <rect width="1200" height="800" fill="url(#fade)" />
          </mask>
        </defs>

        <rect
          x="0"
          y="0"
          width="1200"
          height="800"
          fill="url(#dots)"
          mask="url(#mask)"
        />
      </svg>
    </div>
  );
}

